// Looking for the 'protein-button' add to cart
const buttonProteinSubmit = document.querySelector('.add-upsell-button');
const upsellOverlay = document.querySelector('.complete-overlay-upsell');
const cartCloseIcon = document.querySelector('.cart-close');
    
// Check if the 'protein buy button' is clicked, when clicked, show the upsell
buttonProteinSubmit.addEventListener('click', function() {
  setTimeout(function() {
    openUpsell();
  }, 100 )
});

const buttonSubmit = document.querySelectorAll('.close-upsell-button');

buttonSubmit.forEach(button => {
  button.addEventListener('click', function(){
     closeUpsell();
  });
})

upsellOverlay.addEventListener('click', function() {
  closeUpsell();
})

cartCloseIcon.addEventListener('click', function() {
  closeUpsell();
})

// function open
function openUpsell() {
  document.querySelector('.upsell').classList.add('active');
  upsellOverlay.classList.toggle("open");
}

// function close
function closeUpsell() {
  upsellOverlay.classList.remove("open");
  document.querySelector('.upsell').classList.remove('active')
}